<form #form="ngForm" (ngSubmit)="save(form)" class="roster-project-form">
  <p-message severity="error" text="{{errorMessage}}" *ngIf="errorMessage"></p-message>
  
  <div class="p-fluid p-formgrid-del p-grid p-mt-0">
    <div class="p-field p-col-12 p-md-10 p-mb-0">
      <span class="p-float-label">
        <input pInputText 
              id="title" name="title"
              class="p-inputtext-sm"
              [(ngModel)]="rosterProject.title" />
        <label for="title" class="bold-field blue-field">Title</label>
      </span>
    </div>

    <div class="p-field p-col-12 p-md-2 p-mb-0 p-mt-2">
      <div class="p-field-checkbox">
        <p-checkbox [(ngModel)]="rosterProject.active" binary="true" inputId="active" name="active"></p-checkbox>
        <label for="active">Active</label>
      </div>
    </div>
  </div>

  <div class="p-fluid p-formgrid-del p-grid p-mt-0" *ngIf="canSetPermission()">
    <div class="p-field p-col-12 p-md-10">
      <span class="p-float-label">
        <p-multiSelect [options]="roles" 
                        class="p-inputtext-sm" 
                        name="roles"
                        appendTo="body"
                        [showHeader]="false"
                        [filter]="false"
                        [showToggleAll]="false"
                        inputId="roles" 
                        optionLabel="roleName"
                        optionValue="id"
                        [maxSelectedLabels]="1"                        
                        [(ngModel)]="rosterProject.roleIds">
        </p-multiSelect>
        <label for="rosterCode" class="bold-field blue-field">Assign Roles to Roster Project</label>
      </span>
    </div>
  </div>

  <div class="p-fluid p-formgrid-del p-grid p-mt-0">
    <div class="p-field p-col-12 p-md-12 p-mb-0">
      <p-pickList 
                [source]="workGroups" 
                [target]="selectedWorkGroups" 
                sourceHeader="Available Work Groups ({{workGroups.length}})" 
                targetHeader="Selected Work Groups ({{selectedWorkGroups.length}})" 
                [dragdrop]="false"
                [responsive]="true" 
                [sourceStyle]="{'height':'20rem'}" 
                [targetStyle]="{'height':'20rem'}" 
                [showSourceControls]="false"
                [showTargetControls]="false"
                [showSourceFilter]="false"
                [showTargetFilter]="false"
                filterBy="name">
        <ng-template let-workGroup pTemplate="item">
          <div class="item">
            <div class="item-detail">
              <div class="p-mb-3 p-mt-3">
                <i class="fas fa-user-friends fa-lg"></i> <span class="p-ml-3">{{workGroup.name}}</span>
              </div>
            </div>
          </div>
        </ng-template>
      </p-pickList>      
    </div>
  </div> 

  <div class="modal-footer">
    <button pButton pRipple label="Save" class="p-button p-button-raised" icon="pi pi-save" type="submit"></button>
    <button pButton pRipple label="Cancel" class="p-button p-button-raised p-button-outlined" icon="pi pi-times" type="button" (click)="cancel()"></button>
  </div>
</form>